export default `
<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="6" fill="currentColor"/>

  <g transform="translate(0.5,2.5) scale(0.8)">
    <path d="M11.3359 0.914062C11.5469 1.14844 11.5469 1.5 11.3359 1.71094L5.14844 7.89844C4.91406 8.13281 4.5625 8.13281 4.35156 7.89844L1.16406 4.71094C0.929688 4.5 0.929688 4.14844 1.16406 3.9375C1.375 3.70312 1.72656 3.70312 1.9375 3.9375L4.72656 6.72656L10.5391 0.914062C10.75 0.703125 11.1016 0.703125 11.3125 0.914062H11.3359Z"
      fill="currentColor"/>
  </g>
</svg>
`;